import type { AutocompleteOption } from '@/Components/shadcn';

const supportedLanguages: AutocompleteOption[] = [
    'American Sign Language',
    'Abkhaz',
    'Achinese',
    'Adyghe',
    'Afar',
    'Afrikaans',
    'Ainu',
    'Akan',
    'Albanian',
    'Aleut',
    'Alsatian',
    'Amharic',
    'Arabic',
    'Aragonese',
    'Armenian',
    'Aromanian',
    'Assamese',
    'Asturian',
    'Avar',
    'Aymara',
    'Azerbaijani',
    'British Sign Language',
    'Balochi',
    'Bambara',
    'Bashkir',
    'Basque',
    'Bavarian',
    'Belarusian',
    'Bemba',
    'Bengali',
    'Berber',
    'Bhojpuri',
    'Bihari',
    'Bislama',
    'Boiken',
    'Bosnian',
    'Breton',
    'Buginese',
    'Bulgarian',
    'Burmese',
    'Cantonese',
    'Carolinian',
    'Catalan',
    'Cebuano',
    'Chamorro',
    'Chavacano',
    'Chechen',
    'Cherokee',
    'Chichewa',
    'Chinese',
    'Chittagonian',
    'Choctaw',
    'Church Slavonic',
    'Chuukese',
    'Chuvash',
    'Circassian',
    'Coptic',
    'Cornish',
    'Corsican',
    'Cree',
    'Creole',
    'Crimean Tatar',
    'Croatian',
    'Czech',
    'Dakota',
    'Danish',
    'Dari',
    'Dinka',
    'Divehi',
    'Dogri',
    'Dutch',
    'Dzongkha',
    'Edo',
    'Efik',
    'English',
    'Esan',
    'Esperanto',
    'Estonian',
    'Ewe',
    'Fang',
    'Faroese',
    'Fijian',
    'Filipino',
    'Finnish',
    'French',
    'Frisian',
    'Fulah',
    'Ga',
    'Galician',
    'Garo',
    'Georgian',
    'German',
    'Gondi',
    'Greek',
    'Greenlandic',
    'Guarani',
    'Gujarati',
    'Gusii',
    'Haitian Creole',
    'Hakka',
    'Harari',
    'Hassaniya',
    'Hausa',
    'Hawaiian',
    'Hebrew',
    'Herero',
    'Hiligaynon',
    'Hindi',
    'Hiri Motu',
    'Hmong',
    'Hokkien',
    'Hungarian',
    'Iban',
    'Icelandic',
    'Igbo',
    'Ilocano',
    'Indonesian',
    'Interlingua',
    'Inuktitut',
    'Inupiaq',
    'Irish',
    'Isoko',
    'Italian',
    'Japanese',
    'Javanese',
    'Kabardian',
    'Kabyle',
    'Kachin',
    'Kalmyk',
    'Kannada',
    'Kanuri',
    'Kapampangan',
    'Karakalpak',
    'Karen',
    'Kashmiri',
    'Kashubian',
    'Kazakh',
    'Khasi',
    'Khmer',
    'Kikuyu',
    'Kinyarwanda',
    'Kirghiz',
    'Komi',
    'Kongo',
    'Konkani',
    'Korean',
    'Krio',
    'Kurdish',
    'Langue des Signes française',
    'Ladin',
    'Ladino',
    'Lak',
    'Lamba',
    'Lao',
    'Latin',
    'Latvian',
    'Lezgin',
    'Limburgish',
    'Lingala',
    'Lithuanian',
    'Lozi',
    'Luba-Katanga',
    'Luganda',
    'Luo',
    'Lusoga',
    'Luxembourgish',
    'Macedonian',
    'Maithili',
    'Makonde',
    'Malagasy',
    'Malay',
    'Malayalam',
    'Maltese',
    'Mandarin',
    'Manipuri',
    'Manx',
    'Maori',
    'Marathi',
    'Marshallese',
    'Marwari',
    'Mende',
    'Minangkabau',
    'Mizo',
    'Mon',
    'Mongolian',
    'Montenegrin',
    'Mossi',
    'Nahuatl',
    'Nauru',
    'Navajo',
    'Ndebele',
    'Ndonga',
    'Nepali',
    'Newari',
    'Norwegian',
    'Nuer',
    'Occitan',
    'Odia',
    'Ojibwe',
    'Oromo',
    'Ossetian',
    'Papiamento',
    'Pashto',
    'Pedi',
    'Persian',
    'Pidgin',
    'Plattdeutsch',
    'Polish',
    'Portuguese',
    'Punjabi',
    'Quechua',
    'Rajasthani',
    'Romani',
    'Romanian',
    'Romansh',
    'Rundi',
    'Russian',
    'Sami',
    'Samoan',
    'Sango',
    'Sanskrit',
    'Santali',
    'Sardinian',
    'Scots',
    'Scottish Gaelic',
    'Serbian',
    'Serbo-Croatian',
    'Sesotho',
    'Shan',
    'Shanghainese',
    'Shona',
    'Sicilian',
    'Sign Language',
    'Silesian',
    'Sindhi',
    'Sinhala',
    'Slavic',
    'Slovak',
    'Slovenian',
    'Somali',
    'Sorbian',
    'Spanish',
    'Sundanese',
    'Susu',
    'Swahili',
    'Swazi',
    'Swedish',
    'Sylheti',
    'Syriac',
    'Tahitian',
    'Taiwanese',
    'Tajik',
    'Tamasheq',
    'Tamil',
    'Tatar',
    'Telugu',
    'Temne',
    'Teochew',
    'Teso',
    'Tetum',
    'Thai',
    'Tibetan',
    'Tigre',
    'Tigrinya',
    'Tiv',
    'Tlingit',
    'Tok Pisin',
    'Tonga',
    'Tongan',
    'Tsonga',
    'Tswana',
    'Tumbuka',
    'Turkish',
    'Turkmen',
    'Tuvan',
    'Udmurt',
    'Ukrainian',
    'Urdu',
    'Urhobo',
    'Uyghur',
    'Uzbek',
    'Venda',
    'Vietnamese',
    'Volapük',
    'Walloon',
    'Waray',
    'Warlpiri',
    'Welsh',
    'Wolof',
    'Wu Chinese',
    'Xhosa',
    'Yakut',
    'Yao',
    'Yiddish',
    'Yoruba',
    'Zapotec',
    'Zarma',
    'Zhuang',
    'Zomi',
    'Zulu',
].map((lang) => ({ id: lang, label: lang }));

export default supportedLanguages;
